import moment from 'moment';
import { COMMON_DATE_FORMAT, COMMON_TIME_FORMAT, COMMON_TIME_SECONDS_FORMAT, HIS_COMMON_DATE_FORMAT } from '../shared/constants/commonConstants';
import { format } from 'date-fns';

export const getDate = (date: any): string => {
  return moment(date).format('DD-MM-YYYY');
};

export const getTime = (date: any): string => {
  return moment(date).format(COMMON_TIME_FORMAT);
};

// Format - 11-12-1970 09:01
export const getDateWithTime = (date?: any): string => {
  if (date !== undefined) {
  const output = moment(date).format(`${COMMON_DATE_FORMAT}, ${COMMON_TIME_FORMAT} `);
  return output === 'Invalid date' ? '-' : output;
  } else {
    const output = '-';
    return output;
  }
};

export const getISTDateWithTimeSeconds = (date: any): string => {
  try {
    if (!date) {
      return '-';
    }

    // Parse the input date into a Date object
    const utcDate = typeof date === 'string' ? new Date(date) : new Date(date);

    // Check if the date is valid
    if (isNaN(utcDate?.getTime())) {
      return '-';
    }

    // Format the IST date using the desired format
    return format(utcDate, `${HIS_COMMON_DATE_FORMAT}, ${COMMON_TIME_SECONDS_FORMAT}`);
  } catch (error) {
    // Return '-' if the date is invalid
    return '-';
  }
};

export const getISTDateWithTime = (date?: any): string => {
  const output = moment.utc(date).local().format(`${COMMON_DATE_FORMAT}, ${COMMON_TIME_FORMAT} `);
  return output === 'Invalid date' ? '-' : output;
};
export const getDateWithTextMonth = (date: any): string => `${moment(date).format(COMMON_DATE_FORMAT)}`;

export const getDateWithTextMonthForDDMMYYYY = (date: any): string => `${moment(date, 'DD-MM-YYYY').format(COMMON_DATE_FORMAT)}`;
export const getDefaultTimeline = (): any => ({
  title: 'New admission', remarks: {
    'Remarks for LOS >90 days': undefined,
    'Remarks for delayed intimation': undefined,
    'Remarks for document upload': undefined,
  }, date: getDateWithTime(),
});

export const isDateLessThenToday = (aDate: string, payer: any): boolean =>
  (payer === 'RGI' || payer === 'ABHI') ? moment(aDate).isSameOrBefore(moment(), 'days') : moment(aDate).isBefore(moment(), 'days');

export const getDateDurationInHours = (date: any): any => {
  let duration = 0;
  const _duration = moment.duration(moment().diff(moment(date)));
  duration = _duration.asHours();
  return duration;
};

export const checkAndFormatMomentObject = (dateObject: any): string => {
  if (!dateObject) {
    return 'N/A';
  }
  return moment(dateObject).format('DD/MM/YYYY HH:mm:ss');
};

export const getDateWithMonthText = (date: any): string =>
  `${format(new Date(date), HIS_COMMON_DATE_FORMAT)}`;

export const formattedDate = (dateValue: string): string | null => {
  const date = getDateWithMonthText(dateValue);
  return date === 'Invalid date' ? null : date;
};
